import React from 'react';
import './Footer.css';

const Footer: React.FC = () => (
  <footer className="footer">
    <p className="footer__copy">© 2026 SOFTWARE ENGINEER. BUILT FOR THE ASCENT.</p>
    <div className="footer__links">
      <a href="https://github.com/StinnyJHH" target="_blank" rel="noreferrer" className="footer__link">GITHUB</a>
      <a href="https://www.linkedin.com/in/austinhan98/" target="_blank" rel="noreferrer" className="footer__link">LINKEDIN</a>
    </div>
  </footer>
);

export default Footer;
